import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
export const useIsStoreInMobileOrderDriveThruStores = (storeNumber?: string | null) => {
  const mobileOrderDriveThruStores = useFlag(LaunchDarklyFlag.MOBILE_ORDER_DRIVE_THRU_STORES);

  return mobileOrderDriveThruStores
    ? mobileOrderDriveThruStores.split(',').includes(storeNumber || '')
    : false;
};
